export const testimonials = [
  {
    id: 1,
    name: '漫画迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20friendly%20smile%2C%20simple%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition&width=120&height=120&seq=avatar-xiaoli&orientation=squarish',
    role: '资深漫画读者',
    content: '八仔漫画网真的太好用了！画质清晰，加载速度快，最关键是完全没有广告打扰。全职法师每一话更新我都会第一时间来看，强烈推荐给所有漫画爱好者！',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 2,
    name: '小王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20portrait%20with%20warm%20smile%2C%20simple%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=120&height=120&seq=avatar-xiaowang&orientation=squarish',
    role: '大学生读者',
    content: '宿舍网速不好的时候也能流畅阅读，这个网站真的很良心。分类也很齐全，除了全职法师，我还在这里发现了好多好看的国漫新作。',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: 3,
    name: '老张漫评',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20with%20gentle%20expression%2C%20simple%20neutral%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting%2C%20clean%20minimal%20composition&width=120&height=120&seq=avatar-laozhang&orientation=squarish',
    role: '漫画评论人',
    content: '作为一个看了二十年漫画的老读者，八仔漫画网的阅读体验确实是业界顶尖的。纯净无广告的环境让阅读成为一种享受，全职法师的汉化质量也非常高。',
    rating: 5,
    date: '2026-06-20',
  },
  {
    id: 4,
    name: '漫画少女阿琳',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20portrait%20with%20bright%20smile%2C%20simple%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=120&height=120&seq=avatar-alin&orientation=squarish',
    role: '国漫爱好者',
    content: '每天必刷的漫画网站！更新速度很快，全职法师每次更新我都能在第一时间看到。而且页面设计很清爽，长时间看也不会觉得累。',
    rating: 5,
    date: '2026-06-15',
  },
  {
    id: 5,
    name: '程序员阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20casual%20smile%20wearing%20glasses%2C%20simple%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=120&height=120&seq=avatar-ajie&orientation=squarish',
    role: '漫画读者',
    content: '作为一个技术宅，我特别欣赏八仔漫画网的技术实力。页面响应速度快，图片加载用了懒加载技术，功耗优化也很好，手机上看得久也不发烫。',
    rating: 4,
    date: '2026-06-10',
  },
];

export const faqs = [
  {
    question: '八仔漫画网是否需要付费？',
    answer: '完全不需要！八仔漫画网始终坚持免费阅读的理念，所有漫画内容均可免费在线浏览，不会向用户收取任何费用。',
  },
  {
    question: '全职法师漫画多久更新一次？',
    answer: '全职法师漫画保持每周更新，通常情况下每周三和周六各更新一话。具体更新时间请关注网站首页的最新更新区域。',
  },
  {
    question: '如何在手机上阅读漫画？',
    answer: '八仔漫画网完美适配手机浏览器，您只需在手机浏览器中打开我们的网站即可获得流畅的移动阅读体验，无需下载任何APP。',
  },
  {
    question: '阅读漫画需要注册账号吗？',
    answer: '不需要！八仔漫画网无需注册即可免费阅读所有漫画。我们致力于提供最便捷的阅读体验，去除一切不必要的手续。',
  },
  {
    question: '漫画画质如何？支持放大查看吗？',
    answer: '我们提供原版高清画质漫画，支持双指缩放查看细节。每一页漫画都经过精心处理，确保给您最佳的阅读体验。',
  },
  {
    question: '如果遇到加载问题怎么办？',
    answer: '建议检查网络连接或刷新页面。如果问题持续，可以通过关于我们页面的联系方式向我们反馈，我们会第一时间处理。',
  },
];